<template>
  <div class="user">
    <el-avatar :size="25" :src="circleUrl"></el-avatar>
    <el-dropdown class="username" trigger="click" @command="handleCommand">
      <span class="el-dropdown-link userName">
        <p>{{ this.$store.state.accountInfo.fullName }}</p>
        <i class="el-icon-caret-bottom"></i>
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-if="isShow"
          icon="el-icon-edit-outline"
          command="updateUserInfo"
          >修改资料</el-dropdown-item
        >
        <el-dropdown-item v-if="isShow" icon="el-icon-lock" command="updatePwd"
          >修改密码</el-dropdown-item
        >
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <el-dialog
      :title="updateMessage"
      :visible.sync="dialogTableVisible"
      class="closeModal1"
      :close-on-click-modal="false"
    >
      <updatePwd v-if="updateType === 2" @close="close" />
      <updateUserInfo v-if="updateType === 1" @close="close" />
    </el-dialog>
  </div>
</template>
<script>
import updatePwd from "./update/updatePwd";
import updateUserInfo from "./update/updateUserInfo";

export default {
  name: "currentUser",
  components: {
    updatePwd: updatePwd,
    updateUserInfo: updateUserInfo,
  },
  data() {
    return {
      isShow: true,
      party: null,
      circleUrl:
        "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
      dialogTableVisible: false,
      updateType: 1, //1是更改个人资料 2是更改密码
      updateMessage: "修改个人信息",
      userType: this.$store.state.accountInfo.type, //实际数据库：45 校内 67校外
    };
  },
  methods: {
    close(out) {
      this.dialogTableVisible = false;
      if (out) {
        this.$router.push({ name: "login" });
      }
    },
    handleCommand: function (command) {
      if (command === "logout") {
        sessionStorage.removeItem("token");
        sessionStorage.removeItem("userInfo");
        this.$store.dispatch("logout").then((value) => {
          if (value) {
            this.$router.push({ name: "login" });
          }
        });
      } else if (command === "updateUserInfo") {
        this.dialogTableVisible = true;
        this.updateType = 1;
        this.updateMessage = "修改个人信息";
      } else if (command === "updatePwd") {
        this.dialogTableVisible = true;
        this.updateType = 2;
        this.updateMessage = "修改密码";
      }
    },
  },
  mounted() {
    let userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    this.isShow = userInfo.flag == 30 || userInfo.flag == 40;
  },
};
</script>
<style lang="less" scoped>
.user {
  top: 46%;
  font-size: 12px;
  .username {
    margin-left: 2%;
    color: white;
    > span:first-child {
      display: flex;
      align-items: center;
      i {
        margin-left: 5px;
      }
    }
  }
  .quit {
    margin-left: 5%;
    color: #606060;
    text-decoration: underline;
  }
}
</style>
<style lang="less">
.closeModal1 {
  .el-dialog {
    background-image: url("~@/assets/images/registerbg.jpg");
    background-repeat: no-repeat;
    background-position: bottom;
    background-color: #f1eee7;
    width: 30%;
  }
  .el-dialog__header {
    border: 1px solid #dadada;
    padding-bottom: 22px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/tab/currentUser.vue